export enum DrawerType {
  'store' = 'store',
  'zipcode' = 'zipcode',
  'date' = 'date',
  'delivery' = 'delivery',
  'hamburgerMenu' = 'hamburgerMenu'
}
export type HeaderProps = {
  className?: string;
  openDrawer?: (type: keyof typeof DrawerType, closable?: boolean) => () => void;
  simpleInfo?: ObjectType;
};
